import { Injectable } from '@angular/core';
import { FieldAgentClient, SortParametersDirection, SearchParameters, SortParameters, PagingParameters, SearchParametersDeliverytype } from 'ep-bt-field-agent-proxy';
import { PageNames } from 'ep-bt-controls';
import { EpbtFaSortService } from './epbt-fa-sort.service';
import { EpbtFieldAgentService } from './epbt-field-agent.service';

@Injectable({
    providedIn: 'root'
})
export class EpbtFaProductService {

    public selectedProductItem: any;
    public selectedProductPurchasedbyRequest: any;
    public fromPage: string = PageNames.ProductSearch;
    public selectedStock: any;
    public searchString: string;

    isProductsSearchMessage: boolean = false;
    webTrackUser: any;
    bisTrackSettings: any;

    constructor(private client: FieldAgentClient, private sortService: EpbtFaSortService,
        public faService: EpbtFieldAgentService) {
        this.faService.getBisTrackSetting((bisTrackSetting: any) => {
            this.bisTrackSettings = bisTrackSetting;
        });
        this.faService.getWebTrackUser((webTrackUser: any) => {
            this.webTrackUser = webTrackUser;
        });
    }

    public getProductListGridData(searchString: string, branchId: number, bisTrackUserHasReadAccessToTheseBranches: any, searchMOLTsInProductFindInOrderEntry: boolean, customerId: number, pageSize: number, index: number, subscribe: (bisTrackSetting: any) => void) {
        var searchProductParameters = new SearchParameters();
        searchProductParameters.paging = new PagingParameters();
        searchProductParameters.paging.index = index;
        searchProductParameters.paging.count = index + pageSize;
        searchProductParameters.sorting = new SortParameters();
        searchProductParameters.sorting.sortColumn = this.sortService.productSortValue;
        searchProductParameters.sorting.direction = this.sortService.productDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        searchProductParameters.deliverytype = SearchParametersDeliverytype.All;
        searchProductParameters.productGroupId = 0;
        searchProductParameters.quicklistId = 0;
        searchProductParameters.showProductsInCurrentGroupOnly = true;
        searchProductParameters.customerId = customerId
        searchProductParameters.refineIDs = [""];
        searchProductParameters.refineValues = [""];
        searchProductParameters.branchID = branchId;
        let data = [];
        data.push(bisTrackUserHasReadAccessToTheseBranches.findIndex(item => item.branchID == branchId));
        searchProductParameters.bisTrackUserHasReadAccessToTheseBranchIDs = data;//[0];
        searchProductParameters.searchText = searchString;
        searchProductParameters.includeMOLTProducts = this.fromPage == PageNames.QuickOrderProductSearch && searchMOLTsInProductFindInOrderEntry ? true : false;
        this.client.search(searchProductParameters).subscribe(res => {
            subscribe(res);
        });
    }

    public shouldTallyProduct(tallyLengths: string): boolean {
        // Do not tally if there is no tally length value at all.
        // Yet still tally if there is only a single tally length 
        return tallyLengths != null && tallyLengths != '';
        //return tallyLengths != null && tallyLengths != '' && tallyLengths.includes(',');
    }

    //This method will return single product if the only one record is matching with the search string
    public productSearch(searchString: string = "", subscribe: (bisTrackSetting: any) => void, branchID?: number) {
        var branchId = branchID ? branchID : this.webTrackUser.webTrackTradingBranch.branchID;
        var customerId = this.webTrackUser.customer.customerId;
        var pageSize = 10;

        if (searchString) {
            this.getProductListGridData(searchString, branchId, this.webTrackUser.bisTrackUserHasReadAccessToTheseBranches, this.bisTrackSettings.searchMOLTsInProductFindInOrderEntry, customerId, pageSize, 0, (res: any) => {
                if (res && res.lines.length == 1) {
                    //   this.quickOrderService.productForDesktop = res.lines[0];
                    subscribe(res.lines[0]);
                }
                else
                    subscribe(false);
            });
        }
        else {
            subscribe(false);
        }
    }
}
